import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateNewVehicleLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CreateNewVehicle' */ './components/CreateNewVehicle'
		)
);

export default (store) => {
	return {
		path: 'transport/vehicles/new',
		element: <AsyncLoading component={<CreateNewVehicleLazy />} />,
	};
};
